export const defaultLocale = 'en';
